import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Col, Row, Card, CardBody, Button, Spinner, Input, Alert } from 'reactstrap';

import { connect } from 'react-redux';

import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import 'react-widgets/dist/css/react-widgets.css';

import AutoRefresh from '../../../components/AutoRefresh/AutoRefresh';
import PaymentsTable from './PaymentsTable';
import PaymentsTableAsAdmin from './PaymentsTableAsAdmin';
import PaymentsModals from './PaymentsModals';
import SetupIntents from './SetupIntents';


import {
  createStripeAccount,
  getStripeLoginLink,
  checkStripeCompanyStatus,
  reAuthenticateUser,
  completePhoneVerification,
} from '../../../../actions/user';

import {
  getCompanyPayments,
  getMoreCompanyPayments,
  sortCompanyPayments,
  getSingleCompanyPayment,
  updateLastActive,
  manuallyRedeemPayment,
  getLinkedAPIs,
  getLinkedAPIsAsLinked,
  checkCompanyStatus,
  getCompanySetupIntents,
  companyAcceptCustomRequest,
  companyDeclineCustomRequest,
} from '../../../../actions/company';

import {
  refundStripePayment,
  cancelVoucher,
  resendGiftingEmail,
  openVoucherCodePreview,
} from '../../../../actions/admin';

import {
  getPaymentTooltips,
} from '../../../../actions/contentManagement';

const TableHeight = 500;

class Dashboard extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    fetchStripeLoginLink: PropTypes.func.isRequired,
    getStripeCompanyStatus: PropTypes.func.isRequired,
    addStripeAccount: PropTypes.func.isRequired,
    getSinglePayment: PropTypes.func.isRequired,
    fetchPaymentTooltips: PropTypes.func.isRequired,
    resendEmail: PropTypes.func.isRequired,
    fetchLinkedAPIs: PropTypes.func.isRequired,
    fetchLinkedAPIsAsLinked: PropTypes.func.isRequired,
    checkCompStatus: PropTypes.func.isRequired,
    openCodePreview: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
  };

  constructor(props) {
    super(props);

    const startDate = new Date();
    startDate.setDate(startDate.getDate() - (365 * 2));

    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 1);

    this.state = {
      error: null,
      loading: false,
      showNoPermission: false,
      dontShowPage: false,
      startDate: startDate,
      endDate: endDate,
      sortColumn: 'paymentDate',
      sortType: 'desc',
      codePreviews: {},
      phoneCode: [],
      intervalId: null,
      checkCount: 0,
      redeemedOnly: false,
    };

    this.digit1 = React.createRef();
    this.digit2 = React.createRef();
    this.digit3 = React.createRef();
    this.digit4 = React.createRef();
    this.digit5 = React.createRef();
    this.digit6 = React.createRef();
  }

  handleCodeChange2 = (e) => {
    const { phoneCode } = this.state;

    if (e.target) {
      const { value, name } = e.target;

      let newVal;

      if (value.length) {
        newVal = value[value.length - 1];
      } else {
        newVal = null;
      }

      if (!newVal || !isNaN(newVal)) {
        if (newVal || newVal === 0) {
          phoneCode[name] = newVal.toString();
        } else {
          phoneCode[name] = null;
        }

        if (newVal || newVal === 0) {
          if (name === 0 || name === '0') {
            if (this.digit2) {
              this.digit2.current.focus();
            }
          } else if (name === 1 || name === '1') {
            if (this.digit3) {
              this.digit3.current.focus();
            }
          } else if (name === 2 || name === '2') {
            if (this.digit4) {
              this.digit4.current.focus();
            }
          } else if (name === 3 || name === '3') {
            if (this.digit5) {
              this.digit5.current.focus();
            }
          } else if (name === 4 || name === '4') {
            if (this.digit6) {
              this.digit6.current.focus();
            }
          }
        } else {
          if (name === 1 || name === '1') {
            if (this.digit1) {
              if (value || value === 0 || value === '0') {
                this.digit2.current.focus();
              } else {
                this.digit1.current.focus();
              }
            }
          } else if (name === 2 || name === '2') {
            if (this.digit2) {
              if (value || value === 0 || value === '0') {
                this.digit3.current.focus();
              } else {
                this.digit2.current.focus();
              }
            }
          } else if (name === 3 || name === '3') {
            if (this.digit3) {
              if (value || value === 0 || value === '0') {
                this.digit4.current.focus();
              } else {
                this.digit3.current.focus();
              }
            }
          } else if (name === 4 || name === '4') {
            if (this.digit4) {
              if (value || value === 0 || value === '0') {
                this.digit5.current.focus();
              } else {
                this.digit4.current.focus();
              }
            }
          } else if (name === 5 || name === '5') {
            if (this.digit5) {
              if (value || value === 0 || value === '0') {
                this.digit6.current.focus();
              } else {
                this.digit5.current.focus();
              }
            }
          }
        }

        this.setState({
          phoneCode,
        });
      }
    }
  }

  componentDidMount() {
    const { user, history, getStripeCompanyStatus, getPayments, adminViewAsCompany, updateLastActiveFunc, fetchPaymentTooltips, fetchCompanySetupIntents } = this.props;
    const { redeemedOnly, startDate, endDate } = this.state;

    fetchPaymentTooltips();

    if (user && Object.keys(user).length > 0) {
      if (user.company) {
        updateLastActiveFunc(user.company);

        if (user.role === 'teamOwner' || user.role === 'linkedCompanyUser') {
          getStripeCompanyStatus(user.company).then(() => {
            this.setState({ stripeStatusFetched: true });
          });
          getPayments(user.company, 'custom', startDate, endDate, 'paymentDate', 'desc', null, null, redeemedOnly);
          fetchCompanySetupIntents(user.company);

          this.setState({ showNoPermission: false, dontShowPage: false });
        } else {
          const { roles } = this.props;

          if (roles && roles[user.role] && roles[user.role].permissions && roles[user.role].permissions.payments) {
            getStripeCompanyStatus(user.company).then(() => {
              this.setState({ stripeStatusFetched: true });
            });

            if (user.linkedApi && user.linkedApiName) {
              this.setState({ redeemedByFilter: user.linkedApiName });

              getPayments(user.company, 'custom', startDate, endDate, 'paymentDate', 'desc', user.linkedApiName, null, redeemedOnly);

            } else {
              getPayments(user.company, 'custom', startDate, endDate, 'paymentDate', 'desc', null, null, redeemedOnly);
            }
            fetchCompanySetupIntents(user.company);

            if (roles[user.role].permissions.payments === 2) {
              this.setState({ showNoPermission: false, dontShowPage: false });
            } else {
              this.setState({ showNoPermission: true, dontShowPage: false });
            }
          } else {
            this.setState({ showNoPermission: true, dontShowPage: true });
          }
        }
      } else if (adminViewAsCompany) {
        getStripeCompanyStatus(adminViewAsCompany);

        getPayments(adminViewAsCompany, 'custom', startDate, endDate, 'paymentDate', 'desc', null, null, redeemedOnly);
        fetchCompanySetupIntents(adminViewAsCompany);

      }
    } else {
      history.push('/');
    }
  }

  refresh = () => {
    const { user, getStripeCompanyStatus } = this.props;

    if (user && user.company) {
      getStripeCompanyStatus(user.company);
    }
  }

  addStripeAccount = () => {
    const { user, addStripeAccount, checkCompStatus } = this.props;

    this.setState({ connectStripeProcessing: true, setupActive: true });

    addStripeAccount(user.company).then((res) => {
      if (res && res.data && res.data.accountLinks) {
        this.setState({ connectStripeProcessing: false });

        console.log('res.data.accountLinks.url', res.data.accountLinks.url);

        checkCompStatus(user.company);

        const newWindow = window.open(res.data.accountLinks.url, '_blank');

        setTimeout(() => {
          this.setState({ setupActive: false });
        }, 60000);

        const { intervalId } = this.state;

        console.log('intervalId', intervalId);
        if (!intervalId) {
          intervalId = setInterval(() => {
            console.log('check stripe status');

            checkCompStatus(user.company).then((res) => {
              const { company } = this.props;
              const { checkCount, intervalId } = this.state;
              console.log('check stripe status res', res, company, checkCount);

              if (company && company.validStripe) {
                console.log('is valid stripe, clear');
                clearInterval(intervalId);
              } else if (checkCount < 3) {
                console.log('increase checkCount', checkCount);
                this.setState({ checkCount: checkCount + 1 });
              } else {
                console.log('over check count, stop');
                clearInterval(intervalId);
              }
              
            });
          }, 60000);

          this.setState({ intervalId });
        }

        if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
          //POPUP BLOCKED
          this.setState({ popupBlocked: true });
        } else {
          this.setState({ popupBlocked: false });
        }

        if (newWindow) newWindow.opener = null;
      }
    }).catch(err => {
      this.setState({ connectStripeProcessing: false, popupBlocked: false, setupActive: false });
    });
  }

  sort2 = (sortColumn, sortType) => {
    this.setState({ sortType, sortColumn });

    this.fetchPayments();
  }

  sort = (sortColumn, sortType) => {
    const { user, getPayments, adminViewAsCompany } = this.props;
    const { startDate, endDate, redeemedByFilter, codeFilter, redeemedOnly } = this.state;

    this.setState({ sortType, sortColumn });

    if (startDate && endDate) {
      if (adminViewAsCompany) {
        getPayments(adminViewAsCompany, 'custom', startDate, endDate, sortColumn, sortType, redeemedByFilter, codeFilter, redeemedOnly);
      } else {
        getPayments(user.company, 'custom', startDate, endDate, sortColumn, sortType, redeemedByFilter, codeFilter, redeemedOnly);
      }

    }
  }

  changeStartDate = (date) => {
    this.setState({ startDate: date });
  }

  changeEndDate = (date) => {
    this.setState({ endDate: date });
  }

  changeEndDate = (date) => {
    this.setState({ endDate: date });
  }

  fetchPaymentsRange = () => {
    const { user, getPayments, adminViewAsCompany, loginTime } = this.props;
    const { startDate, endDate, redeemedByFilter, codeFilter, redeemedOnly } = this.state;

    if (startDate && endDate) {
        this.setState({ sortColumn: 'paymentDate', sortType: 'desc', refreshingPayments: true });

        if (adminViewAsCompany) {
          getPayments(adminViewAsCompany, 'custom', startDate, endDate, 'paymentDate', 'desc', redeemedByFilter, codeFilter, redeemedOnly).then(() => {
            this.setState({ refreshingPayments: false });
          });
        } else {
          getPayments(user.company, 'custom', startDate, endDate, 'paymentDate', 'desc', redeemedByFilter, codeFilter, redeemedOnly).then(() => {
            this.setState({ refreshingPayments: false });
          });
        }
    }
  }

  fetchPayments = () => {
    const { user, getPayments, adminViewAsCompany } = this.props;
    const { startDate, endDate, sortColumn, sortType, redeemedByFilter, codeFilter, redeemedOnly } = this.state;

    if (startDate && endDate) {
      if (adminViewAsCompany) {
        getPayments(adminViewAsCompany, 'custom', startDate, endDate, sortColumn, sortType, redeemedByFilter, codeFilter, redeemedOnly);
      } else {
        getPayments(user.company, 'custom', startDate, endDate, sortColumn, sortType, redeemedByFilter, codeFilter, redeemedOnly);
      }

    }
  }

  getMorePayments = () => {
    const { user, getMorePayments, adminViewAsCompany } = this.props;
    const { startDate, endDate, sortColumn, sortType, fetchingPayments, redeemedByFilter, codeFilter, redeemedOnly } = this.state;

    if (!fetchingPayments && !redeemedByFilter && !codeFilter) {
      this.setState({ fetchingPayments: true });

      if (startDate && endDate) {
        if (adminViewAsCompany) {
          getMorePayments(adminViewAsCompany, 'custom', startDate, endDate, sortColumn, sortType, redeemedByFilter, codeFilter, redeemedOnly).then(() => {
            this.setState({ fetchingPayments: false });
          });
        } else {
          getMorePayments(user.company, 'custom', startDate, endDate, sortColumn, sortType, redeemedByFilter, codeFilter, redeemedOnly).then(() => {
            this.setState({ fetchingPayments: false });
          });
        }
      } else {
        this.setState({ fetchingPayments: false });
      }
    }
  }

  onScroll = (x, y) => {
    const { payments } = this.props;
    let contextHeight = payments.length * 46;
    let top = Math.abs(y);

    if (contextHeight - top - TableHeight < 0) {

      if (this.state.scrollTimeout) {
        clearTimeout(this.state.scrollTimeout);
      }

      this.setState({
        scrollTimeout: setTimeout(() => {
          this.getMorePayments();
        }, 700)
      });
    }
  };

  openConfirmRedeemModal = (chargeId, dbId, isLinkedCompany) => {
    const { refundPayment, getSinglePayment, adminViewAsCompany, user } = this.props;

    this.setState({
      confirmRedeemModalOpen: true,
      confirmRedeemModalChargeId: chargeId,
      confirmRedeemModalDbId: dbId,
      isLinkedCompany: isLinkedCompany ? true : false,
      confirmRedeemModalError: null,
      redeemModalProcessing: null,
    });
  }

  closeConfirmRedeemModal = () => {
    this.setState({
      confirmRedeemModalOpen: false,
      confirmRedeemModalChargeId: null,
      confirmRedeemModalDbId: null,
      isLinkedCompany: null,
      confirmRedeemModalError: null,
      redeemModalProcessing: null,
    });
  }

  finishConfirmRedeemModal = () => {
    const { manuallyRedeemPaymentFunction, manuallyRedeemPaymentRegularAPIFunction, getSinglePayment, adminViewAsCompany, user } = this.props;
    const { confirmRedeemModalChargeId, confirmRedeemModalDbId, isLinkedCompany } = this.state;

    this.setState({ redeemModalProcessing: true });

    console.log('chargeId', confirmRedeemModalChargeId, confirmRedeemModalDbId, isLinkedCompany);

    let companyId;

    this.setState({ redeemProcessing: confirmRedeemModalChargeId });

    if (adminViewAsCompany) {
      companyId = adminViewAsCompany;
    } else {
      companyId = user.company;
    }

    let redeemedBy;

    if (user.linkedApiName) {
      redeemedBy = user.linkedApiName;
    } else if (user.linkedApi) {
      redeemedBy = user.linkedApi;
    } else if (!adminViewAsCompany) {
      redeemedBy = user.companyName;
    }

    // manuallyRedeemPaymentFunction(confirmRedeemModalChargeId, confirmRedeemModalDbId, redeemedBy, isLinkedCompany).then(() => {
    manuallyRedeemPaymentFunction(confirmRedeemModalChargeId, confirmRedeemModalDbId, redeemedBy, isLinkedCompany).then((warning) => {
      // A shop refused Steppr's access: the code may still work there
      if (warning) window.alert(warning);
      this.setState({ redeemProcessing: null, redeemModalProcessing: null });

      setTimeout(() => {
        console.log('refresh');
        this.setState({ redeemProcessing: null, redeemModalProcessing: null });

        this.refresh();
        this.fetchPayments();

        this.closeConfirmRedeemModal();
      }, 600);

      setTimeout(() => {
        console.log('refresh2');
        this.refresh();
        this.fetchPayments();
      }, 7500);
    }).catch(err => {
      this.setState({ redeemProcessing: null, confirmRedeemModalError: err, redeemModalProcessing: null });
    });
  }

  openConfirmModal = (type, chargeId, dbId) => {
    this.setState({
      confirmModalOpen: true,
      confirmModalType: type,
      confirmModalChargeId: chargeId,
      confirmModalDbId: dbId,
      onfirmModalError: null,
      confirmModalProcessing: null,
    });
  }

  closeConfirmModal = () => {
    this.setState({
      confirmModalOpen: false,
      confirmModalType: null,
      confirmModalChargeId: null,
      confirmModalDbId: null,
      confirmModalError: null,
      confirmModalProcessing: null,
    });
  }

  finishConfirmModal = () => {
    const { confirmModalType, confirmModalChargeId, confirmModalDbId } = this.state;

    this.setState({ confirmModalProcessing: true });

    if (confirmModalType === 'refundVoucher') {
      this.refundPayment(confirmModalChargeId, confirmModalDbId, 'refundVoucher');
    } else if (confirmModalType === 'refundAll') {
      this.refundPayment(confirmModalChargeId, confirmModalDbId, 'refundAll');
    } else if (confirmModalType === 'refundGifting') {
      this.refundPayment(confirmModalChargeId, confirmModalDbId, 'refundGifting');
    } else if (confirmModalType === 'cancel') {
      this.cancelPayment(confirmModalChargeId, confirmModalDbId);
    } else {
      this.closeConfirmModal();
    }
  }

  refundPayment = (chargeId, dbId, refundType) => {
    const { refundPayment, getSinglePayment, adminViewAsCompany, user } = this.props;

    let companyId;

    this.setState({ refundProcessing: chargeId });

    if (adminViewAsCompany) {
      companyId = adminViewAsCompany;
    } else {
      companyId = user.company;
    }

    refundPayment(chargeId, dbId, refundType).then(() => {
      this.setState({ refundProcessing: null });
      getSinglePayment(companyId, dbId);
      this.closeConfirmModal();
    }).catch(err => {
      this.setState({ refundProcessing: null, confirmModalError: err, confirmModalProcessing: null, });
    });
  }

  cancelPayment = (chargeId, dbId) => {
    const { cancelPayment, getSinglePayment, adminViewAsCompany, user } = this.props;

    this.setState({ cancelProcessing: chargeId });

    let companyId;

    if (adminViewAsCompany) {
      companyId = adminViewAsCompany;
    } else {
      companyId = user.company;
    }

    cancelPayment(chargeId, dbId).then((res) => {
      // A shop refused Steppr's access: the code may still work there
      if (res) window.alert(res);

      this.setState({ cancelProcessing: null });
      getSinglePayment(companyId, dbId);
      this.closeConfirmModal();
    }).catch(err => {
      console.log('cancelPayment err', err);
      this.setState({ cancelProcessing: null, confirmModalError: err, confirmModalProcessing: null, });
    })
  }

  openResendEmail = (chargeId, dbId) => {
    this.setState({ resendEmailOpen: true, resendEmailChargeId: chargeId, resendEmailDbId: dbId, resendEmailProcessing: null, resendEmailError: null });
  }

  closeResendEmail = () => {
    this.setState({ resendEmailOpen: null, resendEmailChargeId: null, resendEmailDbId: null, resendEmailProcessing: null, resendEmailError: null });
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  resendEmail = () => {
    const { resendEmail } = this.props;
    const { resendEmailChargeId, resendEmailDbId, resendEmailValue } = this.state;

    this.setState({ resendEmailProcessing: true });

    if (resendEmailValue) {
      resendEmail(resendEmailChargeId, resendEmailDbId, resendEmailValue).then(() => {
        this.closeResendEmail();
      }).catch(err => {
        this.setState({ resendEmailError: err, resendEmailProcessing: null });
      });
    } else {
      this.setState({ resendEmailError: 'Enter email address' });
    }
  }

  openCodePreview = (dbId) => {
    const { openCodePreview } = this.props;

    openCodePreview(dbId).then((res) => {
      this.setState((prevState) => ({ codePreviews: { ...prevState.codePreviews, [dbId]: res.data } }));
    });
  }

  reAuthenticate = () => {
    const { reAuthenticate } = this.props;
    const { reAuthPassword } = this.state;

    if (reAuthPassword) {
      this.setState({ reAuthSpinner: true });

      reAuthenticate(reAuthPassword).then((res) => {
        console.log('reAuthenticate res', res);

        if (res.verificationId) {
          this.setState({ loading: false, errorGreen: false, show2faModal: true, verificationId: res.verificationId, verificationType: res.verificationType, resolver: res.resolver });
        }

        this.setState({ openReAuthModal: null, reAuthPassword: null, reAuthSpinner: null, reAuthPassword: null });
      }).catch(err => {

        this.setState({ reAuthError: true });
      });
    }
  }

  closeReAuthModal = () => {
    this.setState({ openReAuthModal: null, reAuthPassword: null, reAuthSpinner: null, reAuthPassword: null });
  }

  submitVerificationCode = () => {
    const { completeVerification } = this.props;
    const { verificationId, verificationCode, resolver, phoneCode } = this.state;

    this.setState({ processingSend2fa: true });

    console.log('submitVerificationCode verificationCode', verificationCode, phoneCode);

    if (phoneCode && phoneCode.length === 6) {
      if (phoneCode.includes(null) || phoneCode.includes(undefined)) {
        console.log('invalid values');
      } else {
        console.log('submitVerificationCode phoneCode', phoneCode);

        const phoneCodeString = phoneCode.join('');

        console.log('phoneCodeString phoneCode', phoneCodeString);

        completeVerification({ verificationId, verificationCode: phoneCodeString, resolver }).then((res) => {
          console.log('completeVerification', res);
          this.setState({ processingSend2fa: null, openReAuthModal: null, show2faModal: null, reAuthPassword: null, reAuthError: null });
        });
      }
    }

    if (verificationCode && verificationCode.length === 6) {
    } else {
      this.setState({ processingSend2fa: null });
    }
  }

  close2faModal = () => {
    this.setState({ show2faModal: false, verificationId: null, verificationType: null, resolver: null });
  }

  handleSelect = event => {
    const { linkedCompaniesAPIs, user } = this.props;
    const { value } = event.target;

    if (value === 'all') {
      if (user.linkedApi && user.linkedApiName) {
        this.setState({ redeemedByFilter: user.linkedApiName });
      } else {
        this.setState({ redeemedByFilter: null });
      }
    } else {
      this.setState({ redeemedByFilter: value });
    }
    // this.setState({ alertType: event.target.value });
  };

  checkCompanyStatus = () => {
    const { checkCompStatus, adminViewAsCompany, user } = this.props;
    const { lastRefreshClick } = this.state;

    if (lastRefreshClick && (lastRefreshClick + (1000 * 60)) > Date.now()) {
      console.log('click less than 60s after last');

      this.setState({ lastRefreshTimeout: true });
      return null;
    }

    let companyId;

    if (adminViewAsCompany) {
      companyId = adminViewAsCompany;
    } else {
      companyId = user.company;
    }

    this.setState({ lastRefreshTimeout: null, refreshingCompanyStatus: true, lastRefreshClick: Date.now() });

    this.fetchPayments();

    checkCompStatus(companyId).then(() => {
      this.setState({ refreshingCompanyStatus: false });
    });
  }

  toggleRedeemedOnly = () => {
    this.setState((prevState) => ({ redeemedOnly: !prevState.redeemedOnly }));
  }

  acceptCustomRequest = (dbId) => {
    const { acceptCustomRequest, user, adminViewAsCompany, fetchCompanySetupIntents } = this.props;

    let companyId;

    if (adminViewAsCompany) {
      companyId = adminViewAsCompany;
    } else {
      companyId = user.company;
    }

    this.setState({ acceptSetupIntentProcessing: dbId, declineSetupIntentProcessing: null, acceptSetupIntentError: null, declineSetupIntentError: null });

    acceptCustomRequest(dbId, companyId).then((res) => {
      this.setState({ acceptSetupIntentProcessing: null, declineSetupIntentProcessing: null, acceptSetupIntentError: res === 'success' ? null : true, declineSetupIntentError: null });

      fetchCompanySetupIntents(companyId);
    }).catch(() => {
      this.setState({ acceptSetupIntentProcessing: null, declineSetupIntentProcessing: null, declineSetupIntentError: null, acceptSetupIntentError: true });
    });
  }

  declineCustomRequest = (dbId) => {
    const { declineCustomRequest, user, adminViewAsCompany, fetchCompanySetupIntents } = this.props;

    let companyId;

    if (adminViewAsCompany) {
      companyId = adminViewAsCompany;
    } else {
      companyId = user.company;
    }

    this.setState({ declineSetupIntentProcessing: dbId, acceptSetupIntentProcessing: null, acceptSetupIntentError: null, declineSetupIntentError: null });

    declineCustomRequest(dbId, companyId).then((res) => {
      this.setState({ acceptSetupIntentProcessing: null, declineSetupIntentProcessing: null, declineSetupIntentError: res === 'success' ? null : true, acceptSetupIntentError: null });

      fetchCompanySetupIntents(companyId);
    }).catch(() => {
      this.setState({ declineSetupIntentProcessing: null, acceptSetupIntentProcessing: null, acceptSetupIntentError: null, declineSetupIntentError: true });
    });
  }

  render() {
    const {
      company,
      companyOwnerData,
      stripeAccountStatus,
      stripeChargesEnabled,
      stripePayoutsEnabled,
      adminViewAsCompany,
      payments,
      refundPayment,
      cancelPayment,
      paymentTooltips,
      user,
      companyPaymentsTotal,
      linkedCompaniesAPIs,
      companySetupIntents,
    } = this.props;
    const {
      showNoPermission,
      dontShowPage,
      sortType,
      sortColumn,
      startDate,
      endDate,
      cancelProcessing,
      refundProcessing,
      refundCancelProcessing,
      connectStripeProcessing,
      popupBlocked,
      setupActive,
      stripeStatusFetched,

      confirmModalError,
      confirmModalOpen,
      confirmModalProcessing,
      resendEmailProcessing,
      resendEmailValue,
      resendEmailOpen,
      resendEmailError,

      confirmRedeemModalOpen,
      confirmRedeemModalError,
      redeemProcessing,
      redeemModalProcessing,
      codePreviews,
      openReAuthModal,
      reAuthPassword,
      reAuthError,
      reAuthSpinner,
      show2faModal,
      phoneCode,
      processingSend2fa,
      redeemedByFilter,
      codeFilter,

      refreshingPayments,
      refreshingCompanyStatus,
      lastRefreshTimeout,
      lastRefreshClick,
      redeemedOnly,

      acceptSetupIntentError,
      declineSetupIntentError,
      acceptSetupIntentProcessing,
      declineSetupIntentProcessing,
    } = this.state;

    if (dontShowPage) {
      return (
        <div>
          <Card>
            <CardBody>
              You don't have permissions to view payments
            </CardBody>
          </Card>
        </div>
      );
    }

    console.log('payments payments', payments, popupBlocked, stripeStatusFetched, setupActive);

    if (adminViewAsCompany) {
      return (
          <div>
          <Card style={{ borderRadius: 20 }}>
              <CardBody>
                <Row>
                  <Col xs="10" />
                <Col xs="2">
                  <AutoRefresh refreshFunction={this.refresh} refreshTime={60} />
                </Col>
                </Row>
              <Row style={{ height: 55 }}>
                <Row>
                  <Col xs="12">
                    {(!!acceptSetupIntentError) && <Alert color="danger">{`Failed to accept payment`}</Alert>}
                    {(!!declineSetupIntentError) && <Alert color="danger">{`Failed to decline payment`}</Alert>}
                  </Col>
                </Row>
                <Col style={{ maxWidth: 190 }} >
                    <DateTimePicker
                      className="date-picker"
                      time={false}
                      culture="en"
                      format="MMM DD YYYY"
                      onChange={this.changeStartDate}
                      value={startDate}
                      defaultValue={new Date()} />
                  </Col>
                <Col style={{ maxWidth: 190 }} >
                    <DateTimePicker
                      className="date-picker"
                      time={false}
                      culture="en"
                      format="MMM DD YYYY"
                      onChange={this.changeEndDate}
                      value={endDate}
                    defaultValue={new Date()} />
                  
                </Col>

                {(user.role === 'linkedCompanyUser' || company.linkedCompaniesAccount || user.linkedCompaniesAccount) ? (
                  <Col >
                    <Input
                      type="select"
                      name="select"
                      id="redeemedByFilter"
                      value={redeemedByFilter}
                      onChange={this.handleSelect}
                    >
                      <option value="all">All businesses</option>
                      {linkedCompaniesAPIs ? (Object.keys(linkedCompaniesAPIs).map(key => (
                        <option value={linkedCompaniesAPIs[key].companyName ? linkedCompaniesAPIs[key].companyName : linkedCompaniesAPIs[key].name}>
                          {linkedCompaniesAPIs[key].companyName ? linkedCompaniesAPIs[key].companyName : linkedCompaniesAPIs[key].name}
                        </option>
                      ))): (null)}
                    </Input>
                  </Col>
                ) : (null)}

                <Col style={{ paddingTop: 7, maxWidth: 'fit-content', paddingLeft: 0, paddingRight: 0 }}>
                    <Input
                      type="checkbox"
                      name="redeemedOnly"
                      id="redeemedOnly"
                      checked={redeemedOnly}
                      onChange={this.toggleRedeemedOnly}
                    >
                    </Input>
                  <span style={{ fontSize: 14, paddingLeft: 3 }}>Redeemed only</span>
                  </Col>
                

                <Col style={{ maxWidth: 'fit-content', paddingRight: 0 }}>
                  <Input
                    type="text"
                    name="codeFilter"
                    id="codeFilter"
                    placeholder="Voucher code search"
                    value={codeFilter}
                    onChange={this.handleChange} />
                </Col>
                <Col xs={(user.role === 'linkedCompanyUser' || company.linkedCompaniesAccount || user.linkedCompaniesAccount) ? 4 : 6}>
                  {(lastRefreshTimeout && ((lastRefreshClick + (1000 * 60)) > Date.now())) ? (
                    <Row style={{ position: 'absolute', top: -5 }}>
                      <Col xs="12">
                        Please wait 1 minute
                      </Col>
                    </Row>
                  ): (null)}
                  <Button color="primary" onClick={this.fetchPaymentsRange} style={{ borderRadius: 25, minWidth: 65 }}>
                    Go
                    {(refreshingPayments) ? (
                      <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                    ) : (null)}
                  </Button>
                  <Button onClick={this.checkCompanyStatus} color="primary" style={{ marginLeft: 5, paddingTop: 7, paddingBottom: 5, borderRadius: 25, minWidth: 65 }}>
                    <i class="lni lni-refresh-circle-1-clockwise"></i>
                    {(refreshingCompanyStatus) ? (
                      <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                    ) : (null)}
                  </Button>


                    {(companyOwnerData && companyOwnerData.companyStripeId && stripeAccountStatus) ? (
                      <>
                        {stripeAccountStatus === 'verified' ? (
                        <a href={'https://dashboard.stripe.com/'} style={{ float: 'right', fontSize: 14, paddingLeft: 0, paddingRight: 0 }} target="_blank" rel="noopener noreferrer">
                            <Button color="link"> View payments </Button>
                          </a>
                        ) : (
                          <a href={'https://dashboard.stripe.com/'} style={{ float: 'right', fontSize: 14, paddingLeft: 0, paddingRight: 0 }} target="_blank" rel="noopener noreferrer">
                            <Button color="link"> {`View payments ${!stripeChargesEnabled ? '(Payments Disabled)' : ''} ${!stripePayoutsEnabled ? '(Payouts Disabled)' : ''}`} </Button>
                          </a>
                        )}
                      </>
                    ) : (
                      <Button color="link" style={{ float: 'right', fontSize: 14, paddingLeft: 0, paddingRight: 0 }} disabled> Connect Stripe Account.</Button>
                    )}
                  </Col>
              </Row>
              <Row style={{ marginBottom: 15 }}>
                <Col xs="6" >
                  <Row style={{ marginLeft: 0, lineHeight: '40px', textAlign: 'center', width: '100%', borderRadius: 6, fontSize: 14, height: 40 }}>
                    <Button
                      color="primary"
                      style={{
                        height: 40,
                        padding: 0,
                        width: '20%',
                        borderRadius: '4px 0 0 4px',
                      }}
                    >
                      Sales
                    </Button>
                    <div style={{ padding: 0, width: '25%', height: 40, borderTop: '1px solid #d2d2d2', borderBottom: '1px solid #d2d2d2' }}>
                      {`Face value: £${companyPaymentsTotal.faceValue ? companyPaymentsTotal.faceValue : 0}`}
                    </div>
                    <div style={{ padding: 0, width: '15%', height: 40, borderTop: '1px solid #d2d2d2', borderBottom: '1px solid #d2d2d2' }}>
                      {`Units: ${companyPaymentsTotal.units ? companyPaymentsTotal.units : 0}`}
                    </div>
                    <div style={{ padding: 0, width: '40%', height: 40, borderTop: '1px solid #d2d2d2', borderBottom: '1px solid #d2d2d2', borderRight: '1px solid #d2d2d2', borderRadius: '0 4px 4px 0' }}>
                      {`Customer payments: £${companyPaymentsTotal.amount_captured ? (companyPaymentsTotal.amount_captured / 100).toFixed(2) : 0}`}
                    </div>
                  </Row>
                </Col>
                <Col xs="6">
                  <Row style={{ marginRight: 0, lineHeight: '40px', textAlign: 'center', width: '100%', borderRadius: 6, fontSize: 14, height: 40, whiteSpace: 'nowrap' }}>
                    <Button
                      color="primary"
                      style={{
                        height: 40,
                        padding: 0,
                        width: '20%',
                        borderRadius: '4px 0 0 4px',
                      }}
                    >
                      Redemptions
                    </Button>
                    <div style={{ padding: 0, width: '25%', height: 40, borderTop: '1px solid #d2d2d2', borderBottom: '1px solid #d2d2d2' }}>
                      {`Face value: £${companyPaymentsTotal.redeemedFaceValue ? companyPaymentsTotal.redeemedFaceValue : 0}`}
                    </div>
                    <div style={{ padding: 0, width: '15%', height: 40, borderTop: '1px solid #d2d2d2', borderBottom: '1px solid #d2d2d2' }}>
                      {`Units: ${companyPaymentsTotal.redeemed ? companyPaymentsTotal.redeemed : 0}`}
                    </div>
                    <div style={{ padding: 0, width: '40%', height: 40, borderTop: '1px solid #d2d2d2', borderBottom: '1px solid #d2d2d2', borderRight: '1px solid #d2d2d2', borderRadius: '0 4px 4px 0' }}>
                      {`Customer payments: £${companyPaymentsTotal.redeemed_amount_captured ? (companyPaymentsTotal.redeemed_amount_captured / 100).toFixed(2) : 0}`}
                    </div>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card style={{ borderRadius: 20 }}>
            <CardBody>
              <PaymentsTableAsAdmin
                company={company}
                companyOwnerData={companyOwnerData}
                payments={payments}
                paymentTooltips={paymentTooltips}
                user={user}
                openCodePreview={this.openCodePreview}
                onScroll={this.onScroll}
                sort={this.sort}
                openResendEmail={this.openResendEmail}
                openConfirmRedeemModal={this.openConfirmRedeemModal}
                openConfirmModal={this.openConfirmModal}

                showNoPermission={showNoPermission}
                dontShowPage={dontShowPage}
                sortType={sortType}
                sortColumn={sortColumn}
                cancelProcessing={cancelProcessing}
                refundProcessing={refundProcessing}
                popupBlocked={popupBlocked}
                setupActive={setupActive}
                stripeStatusFetched={stripeStatusFetched}
                resendEmailProcessing={resendEmailProcessing}
                redeemProcessing={redeemProcessing}
                codePreviews={codePreviews}
              />
              <div style={{ textAlign: 'right', color: '#6d6d6d' }}>
                These values are only indicative and may change.
              </div>
            </CardBody>
          </Card>

          <PaymentsModals
            dontShowPage={dontShowPage}
            resendEmailProcessing={resendEmailProcessing}
            phoneCode={phoneCode}
            reAuthError={reAuthError}
            reAuthPassword={reAuthPassword}
            reAuthSpinner={reAuthSpinner}
            openReAuthModal={openReAuthModal}
            confirmRedeemModalOpen={confirmRedeemModalOpen}
            confirmRedeemModalError={confirmRedeemModalError}
            confirmModalOpen={confirmModalOpen}
            confirmModalError={confirmModalError}
            resendEmailOpen={resendEmailOpen}
            resendEmailError={resendEmailError}
            resendEmailValue={resendEmailValue}
            redeemModalProcessing={redeemModalProcessing}
            confirmModalProcessing={confirmModalProcessing}
            processingSend2fa={processingSend2fa}
            show2faModal={show2faModal}

            closeConfirmRedeemModal={this.closeConfirmRedeemModal}
            finishConfirmRedeemModal={this.finishConfirmRedeemModal}
            closeConfirmModal={this.closeConfirmModal}
            finishConfirmModal={this.finishConfirmModal}
            closeResendEmail={this.closeResendEmail}
            handleChange={this.handleChange}
            resendEmail={this.resendEmail}
            closeReAuthModal={this.closeReAuthModal}
            reAuthenticate={this.reAuthenticate}
            close2faModal={this.close2faModal}
            handleCodeChange2={this.handleCodeChange2}
            digit1={this.digit1}
            digit2={this.digit2}
            digit3={this.digit3}
            digit4={this.digit4}
            digit5={this.digit5}
            digit6={this.digit6}
            submitVerificationCode={this.submitVerificationCode}
          />

          <Card style={{ borderRadius: 20 }}>
            <CardBody>
              <SetupIntents
                onScroll={this.onScroll}
                acceptCustomRequest={this.acceptCustomRequest}
                declineCustomRequest={this.declineCustomRequest}

                showNoPermission={showNoPermission}
                dontShowPage={dontShowPage}
                acceptSetupIntentProcessing={acceptSetupIntentProcessing}
                declineSetupIntentProcessing={declineSetupIntentProcessing}
                setupIntents={companySetupIntents}
              />
            </CardBody>
          </Card>
          <div style={{ width: 0, height: 0 }} id="reauth-container"></div>
        </div >
      );
    }

    return (
      <div>
        <Card style={{ borderRadius: 20 }}>
          <CardBody style={{ paddingBottom: 0 }}>
            <Row>
              <Col xs="10" />
              <Col xs="2">
                <AutoRefresh refreshFunction={this.refresh} refreshTime={60} hidden />
              </Col>
            </Row>
            <Row style={{ height: 55 }}>
              <Col style={{ maxWidth: 170 }}>
                <DateTimePicker
                  className="date-picker"
                  time={false}
                  culture="en"
                  format="MMM DD YYYY"
                  onChange={this.changeStartDate}
                  value={startDate}
                  defaultValue={new Date()} />
              </Col>
              <Col style={{ maxWidth: 170, paddingLeft: 0 }}>
                <DateTimePicker
                  className="date-picker"
                  time={false}
                  culture="en"
                  format="MMM DD YYYY"
                  onChange={this.changeEndDate}
                  value={endDate}
                  defaultValue={new Date()} />
              </Col>
              {(user.role === 'linkedCompanyUser' || company.linkedCompaniesAccount || user.linkedCompaniesAccount) ? (
                <Col >
                  <Input
                    type="select"
                    name="select"
                    id="redeemedByFilter"
                    value={redeemedByFilter}
                    onChange={this.handleSelect}
                  >
                    <option value="all">All businesses</option>
                    {linkedCompaniesAPIs ? (Object.keys(linkedCompaniesAPIs).map(key => (
                      <option value={linkedCompaniesAPIs[key].companyName ? linkedCompaniesAPIs[key].companyName : linkedCompaniesAPIs[key].name}>
                        {linkedCompaniesAPIs[key].companyName ? linkedCompaniesAPIs[key].companyName : linkedCompaniesAPIs[key].name}
                      </option>
                    ))) : (null)}
                  </Input>
                </Col>
              ) : (null)}

              <Col style={{ paddingTop: 7, maxWidth: 'fit-content', paddingLeft: 0, paddingRight: 0 }}>
                <Input
                  type="checkbox"
                  name="redeemedOnly"
                  id="redeemedOnly"
                  checked={redeemedOnly}
                  onChange={this.toggleRedeemedOnly}
                >
                </Input>
                <span style={{ fontSize: 14, paddingLeft: 3 }}>Redeemed only</span>
              </Col>

              <Col style={{ maxWidth: 'fit-content', paddingRight: 0 }}>
                <Input
                  type="text"
                  name="codeFilter"
                  id="codeFilter"
                  placeholder="Voucher code search"
                  value={codeFilter}
                  onChange={this.handleChange} />
              </Col>
              <Col xs={(user.role === 'linkedCompanyUser' || company.linkedCompaniesAccount || user.linkedCompaniesAccount) ? 4 : 6}>
                {(lastRefreshTimeout && ((lastRefreshClick + (1000 * 60)) > Date.now())) ? (
                  <Row style={{ position: 'absolute', top: -5 }}>
                    <Col xs="12">
                      Please wait 1 minute
                    </Col>
                  </Row>
                ) : (null)}
                <Button color="primary" onClick={this.fetchPaymentsRange} data-tip data-for='refreshPayments' for="refreshPayments" style={{ borderRadius: 25, minWidth: 65 }}>
                  Go
                  {(refreshingPayments) ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                  ) : (null)}
                </Button>
                <Button onClick={this.checkCompanyStatus} color="primary" style={{ marginLeft: 5, paddingTop: 7, paddingBottom: 5, borderRadius: 25, minWidth: 65 }}>
                  <i class="lni lni-refresh-circle-1-clockwise"></i>
                  {(refreshingCompanyStatus) ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                  ) : (null)}
                </Button>
                {(!setupActive && !popupBlocked && companyOwnerData && companyOwnerData.companyStripeId && stripeAccountStatus) ? (
                  <>
                    {stripeAccountStatus === 'verified' ? (
                      <a href={'https://dashboard.stripe.com/'} style={{ float: 'right', fontSize: 14, paddingLeft: 0, paddingRight: 0 }} target="_blank" rel="noopener noreferrer">
                        <Button color="link"> View payments </Button>
                      </a>
                    ) : (
                      <>
                        <Button color="link" style={{ float: 'right', fontSize: 14, paddingLeft: 0, paddingRight: 0 }} disabled={showNoPermission} onClick={this.addStripeAccount}>
                          {`View payments ${!stripeChargesEnabled ? '(Payments Disabled)' : ''} ${!stripePayoutsEnabled ? '(Payouts Disabled)' : ''}`}
                          {(connectStripeProcessing) ? (
                            <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                          ) : (null)}
                        </Button>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {(!setupActive && !popupBlocked && stripeStatusFetched && companyOwnerData && companyOwnerData.companyStripeId) ? (
                      <Button color="link" style={{ float: 'right', fontSize: 11, maxWidth: '80%', paddingTop: 4 }} disabled={showNoPermission} onClick={this.addStripeAccount}>
                        {/* Stripe account disconnected. To connect a new Stripe account, you need to create a new account on Steppr. */}
                        Please try again
                        {(connectStripeProcessing) ? (
                          <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                        ) : (null)}
                      </Button>
                    ) : (
                          <Button color="link" style={{ float: 'right', fontSize: 14, paddingLeft: 0, paddingRight: 0 }} disabled={showNoPermission} onClick={this.addStripeAccount}>
                        Connect Stripe Account
                        {(connectStripeProcessing) ? (
                          <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                        ) : (null)}
                      </Button>
                    )}
                  </>
                )}
              </Col>
            </Row>

            <Row style={{ marginBottom: 15 }}>
              <Col xs="6" >
                <Row style={{ marginLeft: 0, lineHeight: '40px', textAlign: 'center', width: '100%', borderRadius: 6, border: '0px solid #d2d2d2', fontSize: 14, height: 40 }}>
                  <Button color="primary" style={{ height: 40, padding: 0, width: '20%', marginRight: -5, zIndex: 111 }}>
                    Sales
                  </Button>
                  <div style={{ padding: 0, width: '25%', borderBottom: '1px solid #d2d2d2', borderTop: '1px solid #d2d2d2', height: 40 }}>
                    {`Face value: £${companyPaymentsTotal.faceValue ? companyPaymentsTotal.faceValue : 0}`}
                  </div>
                  <div style={{ padding: 0, width: '15%', borderBottom: '1px solid #d2d2d2', borderTop: '1px solid #d2d2d2', height: 40 }}>
                    {`Units: ${companyPaymentsTotal.units ? companyPaymentsTotal.units : 0}`}
                  </div>
                  <div style={{ padding: 0, width: '40%', borderBottom: '1px solid #d2d2d2', borderTop: '1px solid #d2d2d2', height: 40, borderRight: '1px solid #d2d2d2', borderRadius: '0 6px 6px 0' }}>
                    {`Customer payments: £${companyPaymentsTotal.amount_captured ? (companyPaymentsTotal.amount_captured / 100).toFixed(2) : 0}`}
                  </div>
                </Row>
              </Col>
              <Col xs="6">
                <Row style={{ marginRight: 0, lineHeight: '40px', textAlign: 'center', width: '100%', borderRadius: 6, border: '0px solid #d2d2d2', fontSize: 14, height: 40 }}>
                  <Button color="primary" style={{ height: 40, padding: 0, width: '20%', marginRight: -5, zIndex: 111, whiteSpace: 'nowrap' }}>
                    Redemptions
                  </Button>
                  <div style={{ padding: 0, width: '25%', borderBottom: '1px solid #d2d2d2', borderTop: '1px solid #d2d2d2', height: 40 }}>
                    {`Face value: £${companyPaymentsTotal.redeemedFaceValue ? companyPaymentsTotal.redeemedFaceValue : 0}`}
                  </div>
                  <div style={{ padding: 0, width: '15%', borderBottom: '1px solid #d2d2d2', borderTop: '1px solid #d2d2d2', height: 40 }}>
                    {`Units: ${companyPaymentsTotal.redeemed ? companyPaymentsTotal.redeemed : 0}`}
                  </div>
                  <div style={{ padding: 0, width: '40%', borderBottom: '1px solid #d2d2d2', borderTop: '1px solid #d2d2d2', height: 40, borderRight: '1px solid #d2d2d2', borderRadius: '0 6px 6px 0' }}>
                    {`Customer payments: £${companyPaymentsTotal.redeemed_amount_captured ? (companyPaymentsTotal.redeemed_amount_captured / 100).toFixed(2) : 0}`}
                  </div>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card style={{ borderRadius: 20 }}>
          <CardBody style={{ paddingTop: 0 }}>
            <PaymentsTable
              company={company}
              companyOwnerData={companyOwnerData}
              payments={payments}
              paymentTooltips={paymentTooltips}
              user={user}
              onScroll={this.onScroll}
              openCodePreview={this.openCodePreview}
              sort={this.sort}
              openResendEmail={this.openResendEmail}
              openConfirmRedeemModal={this.openConfirmRedeemModal}
              openConfirmModal={this.openConfirmModal}

              showNoPermission={showNoPermission}
              dontShowPage={dontShowPage}
              sortType={sortType}
              sortColumn={sortColumn}
              cancelProcessing={cancelProcessing}
              refundProcessing={refundProcessing}
              popupBlocked={popupBlocked}
              setupActive={setupActive}
              stripeStatusFetched={stripeStatusFetched}
              resendEmailProcessing={resendEmailProcessing}
              redeemProcessing={redeemProcessing}
              codePreviews={codePreviews}
            />
            <div style={{ textAlign: 'right', fontSize: 14, color: '#616161' }}>
            Values, which update each minute, are only indicative and may change
          </div>
        </CardBody>
        </Card>

        <PaymentsModals
          dontShowPage={dontShowPage}
          resendEmailProcessing={resendEmailProcessing}
          phoneCode={phoneCode}
          reAuthError={reAuthError}
          reAuthPassword={reAuthPassword}
          reAuthSpinner={reAuthSpinner}
          openReAuthModal={openReAuthModal}
          confirmRedeemModalOpen={confirmRedeemModalOpen}
          confirmRedeemModalError={confirmRedeemModalError}
          confirmModalOpen={confirmModalOpen}
          confirmModalError={confirmModalError}
          resendEmailOpen={resendEmailOpen}
          resendEmailError={resendEmailError}
          resendEmailValue={resendEmailValue}
          redeemModalProcessing={redeemModalProcessing}
          confirmModalProcessing={confirmModalProcessing}
          processingSend2fa={processingSend2fa}
          show2faModal={show2faModal}

          closeConfirmRedeemModal={this.closeConfirmRedeemModal}
          finishConfirmRedeemModal={this.finishConfirmRedeemModal}
          closeConfirmModal={this.closeConfirmModal}
          finishConfirmModal={this.finishConfirmModal}
          closeResendEmail={this.closeResendEmail}
          handleChange={this.handleChange}
          resendEmail={this.resendEmail}
          closeReAuthModal={this.closeReAuthModal}
          reAuthenticate={this.reAuthenticate}
          close2faModal={this.close2faModal}
          handleCodeChange2={this.handleCodeChange2}
          digit1={this.digit1}
          digit2={this.digit2}
          digit3={this.digit3}
          digit4={this.digit4}
          digit5={this.digit5}
          digit6={this.digit6}
          submitVerificationCode={this.submitVerificationCode}
        />

        <Card style={{ borderRadius: 20 }}>
          <CardBody style={{ paddingTop: 0 }}>
            <SetupIntents
              onScroll={this.onScroll}
              acceptCustomRequest={this.acceptCustomRequest}
              declineCustomRequest={this.declineCustomRequest}

              showNoPermission={showNoPermission}
              dontShowPage={dontShowPage}
              acceptSetupIntentProcessing={acceptSetupIntentProcessing}
              declineSetupIntentProcessing={declineSetupIntentProcessing}
              setupIntents={companySetupIntents}
            />
          </CardBody>
        </Card>
        <div style={{ width: 0, height: 0 }} id="reauth-container"></div>
      </div >
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  company: state.company.company || {},
  payments: state.company.companyPayments || [],
  stripeAccountStatus: state.user.stripeAccountStatus || null,
  stripeChargesEnabled: state.user.stripeChargesEnabled || null,
  stripePayoutsEnabled: state.user.stripePayoutsEnabled || null,
  roles: state.users.companiesRoles || {},
  adminsRoles: state.admin.adminsRoles || {},
  companyOwnerData: state.company.companyOwnerData || {},
  adminViewAsCompany: state.admin.adminViewAsCompany || null,
  paymentTooltips: state.contentManagement.paymentTooltips || {},
  loginTime: state.user.loginTime || null,
  companyPaymentsTotal: state.company.companyPaymentsTotal || {},
  linkedCompaniesAPIs: state.company.linkedCompaniesAPIs || null,
  companySetupIntents: state.company.companySetupIntents || [],
});

const mapDispatchToProps = {
  getPayments: getCompanyPayments,
  getMorePayments: getMoreCompanyPayments,
  addStripeAccount: createStripeAccount,
  fetchStripeLoginLink: getStripeLoginLink,
  getStripeCompanyStatus: checkStripeCompanyStatus,
  refundPayment: refundStripePayment,
  cancelPayment: cancelVoucher,
  sortPayments: sortCompanyPayments,
  getSinglePayment: getSingleCompanyPayment,
  updateLastActiveFunc: updateLastActive,
  fetchPaymentTooltips: getPaymentTooltips,
  resendEmail: resendGiftingEmail,
  manuallyRedeemPaymentFunction: manuallyRedeemPayment,
  openCodePreview: openVoucherCodePreview,
  reAuthenticate: reAuthenticateUser,
  completeVerification: completePhoneVerification,
  fetchLinkedAPIs: getLinkedAPIs,
  fetchLinkedAPIsAsLinked: getLinkedAPIsAsLinked,
  checkCompStatus: checkCompanyStatus,
  fetchCompanySetupIntents: getCompanySetupIntents,
  acceptCustomRequest: companyAcceptCustomRequest,
  declineCustomRequest: companyDeclineCustomRequest,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
